import * as React from "react"

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list)
  const [removed] = result.splice(startIndex, 1)
  result.splice(endIndex, 0, removed)
  return result
}

function reorderShelfAndProductIndex(products) {
  // 1. Sort by current shelfIndex & productIndex
  const sorted = products.sort((a, b) => {
    const sA = a.shelfIndex.split("-").map(Number)
    const sB = b.shelfIndex.split("-").map(Number)

    for (let i = 0; i < sA.length; i++) {
      if (sA[i] !== sB[i]) return sA[i] - sB[i]
    }

    return Number(a.productIndex) - Number(b.productIndex)
  })

  // 2. Reassign new shelfIndex + productIndex
  return sorted.map((item, index) => ({
    ...item,
    productIndex: String(index + 1), // 1,2,3,4...
    shelfIndex: `1-1-${index + 1}`, // 1-1-1, 1-1-2...
  }))
}
function useShekelState(props) {
  const {
    isEdit = false,
    list = [],
    onUpdate = () => "",
    gondolaTheme,
    getRemainingWidth = 0,
    getPlanogramDetail = {},
    getIsMultipleProduct,
    onUpdateDND,
  } = props || {}

  const [getFetchShekelList, setFetchShekelList] = React.useState([])
  React.useEffect(() => {
    setFetchShekelList(list)
  }, [list])

  const onHandleClickAddCamera = (innerprops) => {
    onUpdate("ADD_CAMERA", innerprops)
  }
  const onHandleClickRemoveCamera = (innerprops) => {
    onUpdate("REMOVE_CAMERA", innerprops)
  }
  const onHandleClickAddProduct = (innerprops) => {
    onUpdate("ADD_PRODUCT", innerprops)
  }
  const onHandleClickUpdateProduct = (innerprops) => {
    onUpdate("UPDATE_PRODUCT", innerprops)
  }
  const onHandleClickRemoveProduct = (innerprops) => {
    onUpdate("REMOVE_PRODUCT", innerprops)
  }
  const onHandleClickAddCell = (innerprops) => {
    onUpdate("ADD_CELL", innerprops)
  }
  const onHandleClickAssociateCell = (innerprops) => {
    let shelfTypeKit = innerprops?.getPlanogramDetail?.shelfType
    let isXShelfType = shelfTypeKit === window?.getShelfTypes?.XSHELF_TYPE_NAME
    onUpdate("ASSOCIATE_CELL", innerprops)
  }
  const onHandleClickRemoveCell = (innerprops) => {
    onUpdate("REMOVE_CELL", innerprops)
  }
  const onHandleClickRemoveAllCell = (innerprops) => {
    onUpdate("REMOVE_ALL_CELL", innerprops)
  }
  const onHandleClickQTYCell = (innerprops) => {
    onUpdate("QTY_CELL", innerprops)
  }
  const onHandleClickQTYProductCell = (innerprops) => {
    onUpdate("QTY_CELL_PRODUCT", innerprops)
  }
  const onHandleClickInfoCell = (innerprops) => {
    onUpdate("INFO_CELL", innerprops)
  }
  const onHandleClickUpdateLocationPositionProduct = (innerprops) => {
    onUpdate("LOCATION_POSITION_CELL", innerprops)
  }

  const onHandleDNDProduct = (innerProps) => {
    const { gindex = "" } = getPlanogramDetail || {}
    const { result = {}, currentCellItem = {}, currentRowItem = {} } =
      innerProps || {}
    let productList = currentCellItem?.multipleProduct
    if (!result.destination) return
    let updated = reorder(
      productList,
      result.source.index,
      result.destination.index
    )

    updated = updated.map((itm, indexKit) => {
      let index = indexKit + 1
      // {`${gindex}-${row_no}-${itemSet?.productIndex}`}
      return {
        ...itm,
        productIndex: index,
        shelfIndex: `${gindex}-${currentRowItem.row_no}-${index}`,
      }
    })

    currentCellItem.multipleProduct = updated
    let index = 0
    currentRowItem.cells = currentRowItem.cells.map((cellItem) => {
      return {
        ...cellItem,
        multipleProduct: cellItem.multipleProduct.map(
          (productItm, indexKit) => {
            index = index + 1
            return {
              ...productItm,
              productIndex: index,
              shelfIndex: `${gindex}-${currentRowItem.row_no}-${index}`,
              shelfIndexBK: `${gindex}-${currentRowItem.row_no}-${index}`,
            }
          }
        ),
      }
    })

    // currentRowItem = updateCurrentRowItem
    onUpdateDND()
  }

  return {
    onHandleDNDProduct,
    gondolaTheme,
    getFetchShekelList,
    setFetchShekelList,
    onHandleClickAddCamera,
    onHandleClickAddProduct,
    onHandleClickAddCell,
    onHandleClickRemoveCell,
    onHandleClickAssociateCell,
    onHandleClickRemoveCamera,
    onHandleClickRemoveAllCell,
    onHandleClickUpdateProduct,
    onHandleClickQTYCell,
    onHandleClickRemoveProduct,
    onHandleClickInfoCell,
    onHandleClickUpdateLocationPositionProduct,
    getRemainingWidth,
    isEdit,
    getPlanogramDetail,
    getIsMultipleProduct,
    onHandleClickQTYProductCell,
  }
}

export { useShekelState }
export default useShekelState
